const GetDocumentData = gql`
  query GetDocumentData($input: DocumentDataInput!) {
    documentData(input: $input)
  }
`;

export default { GetDocumentData };
